import * as React from 'react'

const GoinZones = (props: { className: 'string' }) => {
  return (
    <svg className={'icon ' + props.className} viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
      <g id='Canvas' fill='none'>
        <g id='Goin Zones' clipPath='url(#clip0)'>
          <circle cx='12' cy='12' r='11' strokeWidth='2' id='Ellipse' />
          <circle cx='7' cy='7' r='6' strokeWidth='2' transform='translate(5 5)' id='Ellipse_2' />
          <g id='Ellipse_3' transform='translate(9 9)'>
            <circle cx='3' cy='3' r='3' />
            <circle cx='3' cy='3' r='2' strokeWidth='2' />
          </g>
        </g>
      </g>
      <defs>
        <clipPath id='clip0'>
          <rect width='24' height='24' fill='#fff' />
        </clipPath>
      </defs>
    </svg>
  )
}

export default GoinZones



// WEBPACK FOOTER //
// ./src/components/icons/main-menu/GoinZones.tsx